export const clientAccessSchema = {
    type: 'object',
    properties: {
        CALE: {
            type: 'object',
            properties: {
                key: { type: 'string' },
                scope: {
                    type: 'array',
                    items: { type: 'string' },
                },
            },
        },
    },
};
